import { useEffect } from "react";
import { config } from "@/app/config.js";
import { connectWebSocket, subscribe, EVENTS } from "@/lib/services/ws.service";
import { useCurrentUserStore } from "@/store";
import { useAuthStore } from "@/store/auth.store.js";

export function useWebSocket() {
  const updateUser = useCurrentUserStore((s) => s.updateUser);

  useEffect(() => {
    connectWebSocket();

    let prevToken = useAuthStore.getState().token;
    const unsubAuth = useAuthStore.subscribe((state) => {
      const next = state.token;
      if (next === prevToken) return;
      prevToken = next;
      if (!state.isLoggingOut) {
        connectWebSocket();
      }
    });

    const unsubHydration =
      useAuthStore.persist?.onFinishHydration?.(() => {
        connectWebSocket();
      }) ?? (() => {});

    const unsubUser = subscribe(EVENTS.USER_UPDATED, (payload) => {
      if (payload && typeof payload === "object") {
        updateUser(payload);
      }
    });
    return () => {
      unsubAuth();
      unsubHydration();
      unsubUser();
    };
  }, [updateUser, config.ws.enabled]);
}
